var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDentalStackFavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.9603 22.9463L24.1745 27.376H13.4487V12.0414H11.2413L11.145 32.1611H17.4493C23.5141 32.1611 27.6446 28.0554 29.2229 21.5826L27.9603 22.9463Z",
    fill: "#0095FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8978 29.0936H13.083V7.36841H20.0478C26.5021 7.36841 30.8273 11.682 30.8273 18.1331C30.8273 24.942 26.1125 29.0936 19.8978 29.0936ZM20.0478 10.415H16.1456V26.076H19.8978C24.2812 26.076 27.6729 23.0923 27.6729 18.1307C27.6729 13.5269 24.5499 10.4126 20.0478 10.4126V10.415Z",
    fill: "#735BF2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.4392 23.0683C19.225 23.0683 17.4229 21.1219 17.4229 18.7305H18.6967C18.6967 20.3626 19.928 21.6925 21.4392 21.6925V23.0683Z",
    fill: "#07EBDC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.3896 23.0683V21.6925C22.9008 21.6925 24.1321 20.3626 24.1321 18.7305H25.406C25.406 21.1219 23.6038 23.0683 21.3896 23.0683Z",
    fill: "#07EBDC"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentalStackFavIcon);
export default __webpack_public_path__ + "static/media/DentalStackFavIcon.6275d3448d7f9299308c21a3016c4a36.svg";
export { ForwardRef as ReactComponent };